// #region Imports
import { defineComponent } from 'vue';
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-search-box__tree',
    // #endregion
    // #region Props
    props: {
        nodes: {
            type: Array,
            required: true,
        },
        columns: {
            type: Array,
            required: true,
        },
        iconField: {
            type: String,
            default: null,
        },
        selectedItem: {
            type: Object,
            default: null,
        },
        idField: {
            type: String,
            default: 'id',
        },
        selectLeafOnly: {
            type: Boolean,
            default: false,
        },
        expandedIds: {
            type: Array,
            required: true,
        },
        highlightedIndex: {
            type: Number,
            default: -1,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isLoadingMore: {
            type: Boolean,
            default: false,
        },
    },
    // #endregion
    emits: {
        select: (_item) => true,
        'toggle-node': (_id) => true,
    },
    // #region Computed
    computed: {
        colCount() {
            return (this.iconField ? 1 : 0) + this.columns.length;
        },
    },
    // #endregion
    // #region Methods
    methods: {
        // #region Helper
        isSelected(item) {
            return !!this.selectedItem && this.selectedItem[this.idField] === item[this.idField];
        },
        isNodeExpanded(id) {
            return this.expandedIds.includes(id);
        },
        // #endregion
        // #region Events
        handleRowClick(node) {
            if (this.selectLeafOnly && node.hasChildren) {
                this.$emit('toggle-node', String(node.item[this.idField]));
                return;
            }
            this.$emit('select', node.item);
        },
        // #endregion
    },
    // #endregion
});
// #endregion
